import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const PriceTagIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M11.28 4.24H20.24V13.2L11.7 21.74L2.74 12.78L11.28 4.24ZM5.34 12.78L11.7 19.14L18.5 12.34V5.98H12.14L5.34 12.78ZM14.72 11.56C13.62 11.56 12.76 10.7 12.76 9.6C12.76 8.5 13.62 7.64 14.72 7.64C15.82 7.64 16.68 8.5 16.68 9.6C16.68 10.7 15.82 11.56 14.72 11.56Z" />
    </SvgIcon>
  );
});
